<div class="spinner-body">
    <div class="spinner-box">
      <div class="img"></div>
      <div class="circle-border">
        <div class="circle-core"></div>
      </div>
    </div>
  </div>
  
<style>
    .spinner-body {
    width: 100vw;
    background: rgba(0, 0, 0, 0.87);
    height: 100vh;
    z-index: 99999;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner-box {
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    position: relative;
  }
  
  .circle-border {
    width: 160px;
    height: 160px;
    padding: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: #ee3123;
    background: linear-gradient(0deg, rgba(255, 81, 81, 0.1) 33%, #ee3123 100%);
    animation: spin 0.8s linear 0s infinite;
  }
  
  .circle-core {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    border-radius: 50%;
    position: relative;
  }
  
  .img {
    position: absolute;
    top: 29.5%;
    z-index: 22;
    border-radius: 50%;
    width: 125px;
    height: 125px;
    background-image: url(/assets/red-globe.svg);
    background-size: 16rem;
    animation: bg-spin 5s linear 0s infinite;
    box-shadow: 0px 4px 137px rgba(0, 0, 0, 0.49);
  }
  
  @keyframes spin {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(359deg);
    }
  }
  
  @keyframes bg-spin {
    100% {
      background-position: 100%;
    }
  }
  
  @media (min-width: 768px) {
  }
  
</style>